import App from '@/models/App'

export default class OrderingOrdererEstimateExpense extends App {
    static get entity() {
        return 'OrderingOrdererEstimateExpenses'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingEstimateId: this.attr(''),
            name: this.attr(''),
            currency: this.attr(''),
            price: this.attr(0),
            taxCategory: this.attr(''),
            taxRate: this.attr(0),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            create(orderingShipId, orderingOrderId, orderingEstimateId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/expenses`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateExpenseId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/expenses/${orderingEstimateExpenseId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateExpenseId) {
                return this.delete(
                    `ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/expenses/${orderingEstimateExpenseId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingEstimateExpenseId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
